import { RouteObject } from 'react-router-dom'

import { default as VenueOnboarding } from '.'
import { PageLayout } from '../../../common/app'

export const venueOnboardingRoutes: RouteObject[] = [
  {
    path: '/venue-onboarding',
    element: (
      // htmlTitleOnly: the embedded guide is the whole page - a PageHeader
      // would only push the full-height iframe below the fold.
      <PageLayout title="Venue Onboarding" htmlTitleOnly>
        <VenueOnboarding.VenueOnboarding.Component />
      </PageLayout>
    ),
    loader: VenueOnboarding.VenueOnboarding.Loader,
  },
]
